module.exports = __webpack_public_path__ + "static/media/VSERIESIMAGE.5a246f62.png";